import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Constants } from '../../../common/helper/Constants';
import { VersionLogService } from '../../../feature/version-log/version-log.service';
import { VersionLog } from '../../../feature/version-log/model/version-log';

@Component({
  selector: 'gate-footer',
  standalone: true,
  imports: [TranslatePipe, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  routes = Constants.routes;
  year = new Date().getFullYear();
  version = 'x.x';

  constructor(private versionLogService: VersionLogService){
    this.getVersionLog();
  }
    private getVersionLog() {
      this.versionLogService
        .getVersionLog()
        .then((result: VersionLog[]) => {
          var versionLogs= this.sortVersionLogs(result); // Update the serviceReports signal
          if(versionLogs && versionLogs.length >0){
            this.version = (versionLogs[0].version?.major ?? 0) +'.'+ (versionLogs[0].version?.minor ?? 0) + (versionLogs[0].version?.patch?'.' +versionLogs[0].version?.patch:'');
          }
        })
        .catch((error) => {
          console.error('Error fetching getVersionLog:', error); // Log error to console
        });
    }

sortVersionLogs(versionLogs: VersionLog[]) {
  return versionLogs.sort((a, b) => {
    const majorA = a.version?.major ?? 0;
    const minorA = a.version?.minor ?? 0;
    const patchA = a.version?.patch ?? 0;

    const majorB = b.version?.major ?? 0;
    const minorB = b.version?.minor ?? 0;
    const patchB = b.version?.patch ?? 0;

    // Compare major versions first
    if (majorB != majorA) {
      return majorB - majorA;
    }

    // Then compare minor versions
    if (minorB != minorA) {
      return minorB - minorA;
    }

    // Then compare patch versions
    return patchB - patchA;
  });
}

}
